import { Redirect } from 'expo-router';

import { routes } from '@fhs-legacy/frontend/src/utils/routing';

/**
 * The legacy support form is no longer supported (the support chatbot replaced it).
 * Send anyone landing here to the chatbot support page.
 */
export default function SupportFormRedirect() {
  return <Redirect href={routes.support} />;
}
